import { useSelector } from 'react-redux';

export default function useLocale() {
    const language = useSelector((state) => state.locale);

    return language || 'fr';
}
